const notifySuccess = (dispatch, message) => {
  dispatch('notifications/notifySuccess', { message }, { root: true })
}

export default notifySuccess
